<template>
    <svg width="28" height="14" viewBox="0 0 28 14" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M27.5 13.5C16 13.5 21.4558 3 14 3C6.54416 3 10 13.5 0.5 13.5C0.5 6.04416 6.54416 0 14 0C21.4558 0 27.5 6.04416 27.5 13.5Z"
            fill="#A1FF99"
        />
    </svg>
</template>
